import React from 'react';
import { motion } from 'framer-motion';
import { NetworkIcon, GemIcon, TargetIcon, ScrollIcon } from 'lucide-react';
const solutions = [{
  icon: <NetworkIcon className="w-6 h-6" data-id="element-169" />,
  title: 'Unified Realm Network',
  description: 'One syndication hub connecting 200+ fantasy & entertainment publishers, blogs, podcasts, and streaming platforms. Distribute your lore with a single incantation.'
}, {
  icon: <GemIcon className="w-6 h-6" data-id="element-170" />,
  title: 'Enchanted Monetization',
  description: "Command premium CPMs averaging €12-€28 through fantasy-endemic advertisers who truly value your audience's engagement and loyalty."
}, {
  icon: <TargetIcon className="w-6 h-6" data-id="element-171" />,
  title: 'Arcane Targeting',
  description: "AI-powered audience matching that understands the nuances of fantasy subgenres, ensuring your grimdark epic doesn't end up in front of cozy fantasy readers."
}, {
  icon: <ScrollIcon className="w-6 h-6" data-id="element-172" />,
  title: 'The Oracle Dashboard',
  description: 'Deep analytics built specifically for entertainment content: engagement heatmaps, audience affinity scores, and cross-platform attribution revealed in clear visions.'
}];
export const Solutions = () => {
  return <section id="solutions" className="py-24 bg-burgundy-950 relative overflow-hidden" data-id="element-173">
      {/* Background flourishes */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-burgundy-800/20 to-transparent pointer-events-none" data-id="element-174"></div>
      <div className="absolute bottom-0 left-0 w-1/2 h-full bg-[radial-gradient(circle_at_bottom_left,_var(--tw-gradient-stops))] from-gold-900/10 to-transparent pointer-events-none" data-id="element-175"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-176">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-177">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:w-1/3" data-id="element-178">
            <h2 className="font-display text-4xl md:text-5xl text-gold-500 mb-6 leading-tight" data-id="element-179">
              The Mythicplay <br data-id="element-180" /> Covenant
            </h2>
            <div className="w-24 h-1 bg-gold-600 mb-8" data-id="element-181"></div>
            <p className="text-xl text-parchment-200 mb-8 leading-relaxed" data-id="element-182">
              We forge alliances between creators and audiences, banishing the
              chaos of modern distribution with tools forged in the fires of
              specialized syndication.
            </p>
            <p className="text-lg text-parchment-300 italic" data-id="element-183">
              "A single platform to bind them, and in the network, find them."
            </p>
          </motion.div>

          <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-184">
            {solutions.map((solution, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="border border-gold-700/30 bg-burgundy-900/40 p-8 hover:bg-burgundy-900/60 transition-colors duration-300 group" data-id="element-185">
                <div className="w-12 h-12 rounded-full border border-gold-600 flex items-center justify-center text-gold-400 mb-6 group-hover:scale-110 transition-transform duration-300 group-hover:shadow-gold-glow bg-burgundy-950" data-id="element-186">
                  {solution.icon}
                </div>
                <h3 className="font-heading text-xl font-bold text-parchment-100 mb-3" data-id="element-187">
                  {solution.title}
                </h3>
                <p className="text-parchment-300 leading-relaxed" data-id="element-188">
                  {solution.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};